// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"374":"1749d207","872":"44915227"}[chunkId] + ".chunk.css";
};